import {
  Accordion,
  Anchor,
  Box,
  Button,
  Flex,
  Group,
  Menu,
  Stack,
  Text,
  Title,
} from '@mantine/core'
import { useState } from 'react'
import { IconChevronDown, IconList } from '@tabler/icons-react'
import cn from 'classnames'
import baseClasses from '@styles/record.module.css'
import classes from './Home.module.css'

export const Home = () => {
  const [fieldsVisible, setFieldsVisible] = useState<boolean>(true)

  const MOCK_FIELDS = Array(4).fill({
    label: 'Custom Field Label',
    value: 'Value',
  })

  const handleToggleFields = () => {
    setFieldsVisible(!fieldsVisible)
  }

  return (
    <Box className={baseClasses.Record__content} p="md">
      <Flex justify="flex-end">
        <Group>
          <Anchor onClick={handleToggleFields}>
            {fieldsVisible ? 'Hide' : 'View'} all fields
          </Anchor>
          <Menu shadow="md">
            <Menu.Target>
              <Button
                variant="default"
                rightSection={<IconChevronDown size={18} />}
              >
                Edit Fields
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Edit Fields</Menu.Item>
              <Menu.Item>Edit Layout</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>
      </Flex>
      <Flex align="flex-start">
        <Flex w={300} mt="xl" px="lg">
          <Stack style={{ flexGrow: 1 }}>
            <Group>
              <IconList size={22} />
              <Text size="xl">Table of contents</Text>
            </Group>
            <Flex>
              <Flex direction="column" style={{ flexGrow: 1 }}>
                <Box
                  className={cn(classes.Record__home__tableOfContents, {
                    [classes.Record__tableOfContents__Active]: true,
                  })}
                >
                  <Text>Section Title</Text>
                </Box>
                <Box className={classes.Record__home__tableOfContents}>
                  Section Title
                </Box>
                <Box className={classes.Record__home__tableOfContents}>
                  Section Title
                </Box>
                <Box className={classes.Record__home__tableOfContents}>
                  Section Title
                </Box>
              </Flex>
            </Flex>
          </Stack>
        </Flex>
        <Accordion
          value={fieldsVisible ? ['0', '1', '2', '4'] : []}
          style={{ flexGrow: 1 }}
          multiple
        >
          <Accordion.Item key="0" value="0">
            <Accordion.Control>
              <Title order={4} pr="lg">
                Custom Section Title
              </Title>
            </Accordion.Control>
            <Accordion.Panel>
              <Stack gap="xs">
                {MOCK_FIELDS.map((field: any, index: number) => (
                  <Stack gap={0} key={`fields-${index}`}>
                    <Text size="sm" c="gray.6">
                      {field.label}
                    </Text>
                    <Text c="dark" size="sm">
                      {field.value}
                    </Text>
                  </Stack>
                ))}
              </Stack>
            </Accordion.Panel>
          </Accordion.Item>
          <Accordion.Item key="1" value="1">
            <Accordion.Control>
              <Title order={4} pr="lg">
                Custom Section Title
              </Title>
            </Accordion.Control>
            <Accordion.Panel>
              <Stack gap="xs">
                {MOCK_FIELDS.map((field: any, index: number) => (
                  <Stack gap={0} key={`fields-${index}`}>
                    <Text size="sm" c="gray.6">
                      {field.label}
                    </Text>
                    <Text c="dark" size="sm">
                      {field.value}
                    </Text>
                  </Stack>
                ))}
              </Stack>
            </Accordion.Panel>
          </Accordion.Item>
          <Accordion.Item key="2" value="2">
            <Accordion.Control>
              <Title order={4} pr="lg">
                Custom Section Title
              </Title>
            </Accordion.Control>
            <Accordion.Panel>
              <Stack gap="xs">
                {MOCK_FIELDS.map((field: any, index: number) => (
                  <Stack gap={0} key={`fields-${index}`}>
                    <Text size="sm" c="gray.6">
                      {field.label}
                    </Text>
                    <Text c="dark" size="sm">
                      {field.value}
                    </Text>
                  </Stack>
                ))}
              </Stack>
            </Accordion.Panel>
          </Accordion.Item>
          <Accordion.Item key="3" value="3">
            <Accordion.Control>
              <Title order={4} pr="lg">
                Custom Section Title
              </Title>
            </Accordion.Control>
            <Accordion.Panel>
              <Stack gap="xs">
                {MOCK_FIELDS.map((field: any, index: number) => (
                  <Stack gap={0} key={`fields-${index}`}>
                    <Text size="sm" c="gray.6">
                      {field.label}
                    </Text>
                    <Text c="dark" size="sm">
                      {field.value}
                    </Text>
                  </Stack>
                ))}
              </Stack>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      </Flex>
    </Box>
  )
}
